module.exports = __webpack_public_path__ + "media/images/app/how-it-works/subscription-box-9bbdb2a8e0a9ec59a6c68f83528b4b65.webp";